import React, { useState, useRef, useEffect, useMemo } from "react";
import classNames from "classnames";
import styles from "./EventsDetailsPage.module.css";
import { v4 } from "uuid";

// import Header from "shared/Header";
import DocumentsList from "../DocumentsList";
import KeyContactsList from "../KeyContactsList";
import FilterNearbyIncidentsMenu from "../FilterNearbyIncidentsMenu";
import { Select } from "shared/Select/Select";
import IncidentsList from "Security/IncidentsPage/IncidentsList";
import EmergencyList from "../EmergencyList";
import EventInfoCard from "../EventInfoCard";
import EventCenterInfoCard from "../EventCenterInfoCard";
import { TabContainer, Tab } from "shared/TabContainer";
import Card from "shared/Card";
import KeyLocationsList from "../KeyLocationsList";
import SpecialCircumstances from "../SpecialCircumstances";
import EditKeyContactsModal from "../EditKeyContactsModal";
import SecurityTeamList from "../SecurityTeamList";
import SecurityBriefDocument from "../SecurityBriefDocument";
import EventSummaryDocument from "../EventSummaryDocument";

import { ReactComponent as PrinterIcon } from "../../assets/print-light.svg";
import { ReactComponent as FloppyDiskIcon } from "../../assets/floppy-disk-light.svg";
import { ReactComponent as EnvelopeIcon } from "../../assets/envelope-light.svg";

// Mock Data (DELETE)
import { Default as EventInfoCardData } from "../EventInfoCard/EventInfoCard.stories";
import { Default as EventCenterInfoCardData } from "../EventCenterInfoCard/EventCenterInfoCard.stories";
import { Default as EmergencyListData } from "../EmergencyList/EmergencyList.stories";
import { Default as KeyLocationsListData } from "../KeyLocationsList/KeyLocationsList.stories";
import { Default as DocumentsListData } from "../DocumentsList/DocumentsList.stories";
import { WithEdit as KeyContactsListData } from "../KeyContactsList/KeyContactsList.stories";
import { Default as SecurityTeamListData } from "../SecurityTeamList/SecurityTeamList.stories";
import { Example as IncidentsListData } from "Security/IncidentsPage/IncidentsList/IncidentsList.stories";
import TestSecurityBrief from "../utils/dummy.pdf";
import { Default as EventSummaryDocumentProps } from "../EventSummaryDocument/EventSummaryDocument.stories";

export function EventsDetailsPage() {
  // Actions Select
  const [isOpenActions, setIsOpenActions] = useState(false);

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setIsOpenActions(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  // Security Brief Document
  const [securityBriefDocument, setSecurityBriefDocument] = useState("");

  // Special Circumstances
  const [specialCircumstances, setSpecialCircumstances] = useState("");

  // Lists (Staff)
  const [mockSecurityTeamList, setMockSecurityTeamList] = useState([
    ...SecurityTeamListData.args.securityTeamList,
  ]);

  const [mockEventStaffList, setMockEventStaffList] = useState([
    ...SecurityTeamListData.args.securityTeamList,
  ]);

  const onMockPinStaff = (pinStatus, team, list) => {
    const newList = [];
    let editedTeam;

    // When unpinned, the item is returned at the end of the list.
    // When pinned, the item is returned at the top of the list.
    list.forEach((_team) => {
      if (_team.email === team.email) {
        editedTeam = { ...team, pinned: pinStatus };
      } else newList.push(_team);
    });

    pinStatus ? newList.unshift(editedTeam) : newList.push(editedTeam);
    return newList;
  };

  // Incidents
  const [mockIncidents, setMockIncidents] = useState([
    
    {
      pendingSuspension: {
        platforms: ["CommuniKate", "Events"],
        suspendUntil: "2223-07-08T02:45:21.850Z",
        reason: "Harrasment2",
        reminderDate: "2023-07-09T02:45:21.850Z",
      },
      startDate: {
        month: "February",
        day: 1,
        year: 2022,
      },
      complaintAgainst: {
        iboNumber: 6983642,
        email: "dreamstream+qa.6983642.1445048.5@wwdb.com",
        firstName: "JAMES",
        lastName: "ABADILLA",
        phoneNumber: "(702) 461-2597",
        address: "asdf",
        city: "wa",
        state: "wa",
        zipCode: "12312",
      },
      documentation: {
        evidence: [],
      },
      _id: "64a7892398d2360423c4aad4",
      primaryIboNumber: 752313,
      primaryEmail: "dreamstream+qa.752313.643746.17@wwdb.com",
      firstName: "GERRI",
      lastName: "DICKEY",
      phoneNumber: "(509) 123-4567",
      address: "8518 N WEIPERT DR",
      city: "SPOKANE",
      state: "WA",
      zipCode: "99208-5935",
      problemType: "Violence",
      problemLocation: "In Person",
      subLocation: "DreamStream",
      description: "asdf",
      evidence: [
        {
          type: "image/jpeg",
          src: "https://wwgusdev.blob.core.windows.net/security-app/fead4bc0-1c77-11ee-a09e-bb4edeac43c2.jpg",
          name: "GettyImages-1145794687 - Copy.jpg",
          downloadPath: "security-app/fead4bc0-1c77-11ee-a09e-bb4edeac43c2.jpg",
        },
      ],
      isMember: "Yes",
      hasViolated: "Yes",
      fromUpline: "No",
      recentActivity: [
        {
          date: "2023-07-08T02:45:22.088Z",
          message:
            "Suspended email sent to suspended user: dreamstream+qa.6983642.1445048.5@wwdb.com",
          _id: "64a8cdc2dc55e7052403d119",
        },
        {
          date: "2023-07-08T02:44:18.771Z",
          message:
            "Suspended email sent to suspended user: dreamstream+qa.6983642.1445048.5@wwdb.com",
          _id: "64a8cd8208e6a630dff65b50",
        },
        {
          date: "2023-07-08T02:43:38.916Z",
          message:
            "Suspended email sent to suspended user: dreamstream+qa.6983642.1445048.5@wwdb.com",
          _id: "64a8cd5a0a8a795d3aedc775",
        },
        {
          date: "2023-07-08T02:43:33.107Z",
          message:
            "Suspended email sent to suspended user: dreamstream+qa.6983642.1445048.5@wwdb.com",
          _id: "64a8cd55dc55e7052403d100",
        },
        {
          date: "2023-07-08T02:27:58.260Z",
          message:
            "Suspended email sent to suspended user: dreamstream+qa.6983642.1445048.5@wwdb.com",
          _id: "64a8c9ae0a8a795d3aedc761",
        },
        {
          date: "2023-07-07T04:46:36.141Z",
          message:
            "Suspended email sent to suspended user: dreamstream+qa.6983642.1445048.5@wwdb.com",
          _id: "64a798ac64bd9b2390aaefb0",
        },
      ],
      reminders: [],
      incidentNotes: [],
      events: [],
      historyOfActions: [
        {
          text: "User has been suspended",
          createdAt: "2023-07-08T02:45:22.089Z",
          _id: "64a8cdc2dc55e7052403d11a",
        },
        {
          text: "User has been suspended",
          createdAt: "2023-07-08T02:44:18.772Z",
          _id: "64a8cd8208e6a630dff65b51",
        },
        {
          text: "User has been suspended",
          createdAt: "2023-07-08T02:43:38.917Z",
          _id: "64a8cd5a0a8a795d3aedc776",
        },
        {
          text: "User has been suspended",
          createdAt: "2023-07-08T02:43:33.111Z",
          _id: "64a8cd55dc55e7052403d101",
        },
        {
          text: "User has been suspended",
          createdAt: "2023-07-08T02:27:58.263Z",
          _id: "64a8c9ae0a8a795d3aedc762",
        },
        {
          text: "User has been suspended",
          createdAt: "2023-07-07T04:46:36.144Z",
          _id: "64a798ac64bd9b2390aaefb1",
        },
      ],
      createdAt: "2023-07-07T03:40:19.793Z",
      updatedAt: "2023-07-08T02:45:22.090Z",
      __v: 0,
      id: "64a7892398d2360423c4aad4",
    },
    {
      escalation: {
        reason: "sadf",
        actionsNeeded: "sadf",
        createdAt: "2023-07-07T02:40:55.752Z",
      },
      notes: {
        title: "Escalated - Investigation",
        body: "sadf - sadf",
        createdAt: "2023-07-07T02:40:55.752Z",
      },
      pendingSuspension: {
        platforms: [],
      },
      startDate: {
        month: "January",
        day: 1,
        year: 2021,
      },
      complaintAgainst: {
        iboNumber: 1478107,
        email: "dreamstream+qa.1478107.1463.5@wwdb.com",
        firstName: "RANDY",
        lastName: "JASSMAN",
        phoneNumber: "(509) 995-6003",
        address: "1717 PENINSULA RD",
        city: "HOPE",
        state: "ID",
        zipCode: "83836-9753",
      },
      documentation: {
        evidence: [],
      },
      _id: "64a775fc9066ab70a9f461ff",
      primaryIboNumber: 138306,
      primaryEmail: "notprovided@email.com",
      firstName: "TESS",
      lastName: "MILLER",
      phoneNumber: "(406) 580-5898",
      address: "681 CANDLELIGHT DR",
      city: "BOZEMAN",
      state: "MT",
      zipCode: "59718",
      problemType: "Hate Speech/Racism",
      problemLocation: "In Person",
      subLocation: "Communicate",
      description: "asdf",
      evidence: [
        {
          type: "image/jpeg",
          src: "https://wwgusdev.blob.core.windows.net/security-app/94228500-1c6c-11ee-a9ff-7b9387134cde.jpg",
          name: "GettyImages-1145794687.jpg",
          downloadPath: "security-app/94228500-1c6c-11ee-a9ff-7b9387134cde.jpg",
        },
      ],
      isMember: "Yes",
      hasViolated: "Yes",
      fromUpline: "Yes",
      recentActivity: [
        {
          date: "2023-07-07T05:00:13.138Z",
          message: "Caution Letter email sent to: notprovided@email.com",
          _id: "64a79bdd9066ab70a9f472b2",
        },
      ],
      reminders: [],
      incidentNotes: [
        {
          title: "123",
          text: "123",
          files: [
            {
              type: "image/jpeg",
              src: "https://wwgusdev.blob.core.windows.net/security-app/dda0d770-1c6e-11ee-bad0-35942e23f811.jpg",
              name: "GettyImages-1145794687 - Copy.jpg",
              downloadPath:
                "security-app/dda0d770-1c6e-11ee-bad0-35942e23f811.jpg",
            },
          ],
          createdAt: "2023-07-07T02:34:58.532Z",
          _id: "64a779d24a027297a275730a",
        },
        {
          title: "123",
          text: "123",
          files: [
            {
              type: "image/jpeg",
              src: "https://wwgusdev.blob.core.windows.net/security-app/16b476d0-1c6e-11ee-a09e-bb4edeac43c2.jpg",
              name: "GettyImages-1145794687 - Copy.jpg",
              downloadPath:
                "security-app/16b476d0-1c6e-11ee-a09e-bb4edeac43c2.jpg",
            },
          ],
          createdAt: "2023-07-07T02:29:24.793Z",
          _id: "64a7788598d2360423c4a1f2",
        },
        {
          title: "123",
          text: "123",
          files: [],
          createdAt: "2023-07-07T02:29:15.601Z",
          _id: "64a7787b4a027297a27571c6",
        },
      ],
      events: [],
      historyOfActions: [
        {
          text: "Escalated - Investigation",
          createdAt: "2023-07-07T02:40:55.752Z",
          _id: "64a77b3764bd9b2390aae4db",
        },
        {
          text: "Note added to case by TESS",
          createdAt: "2023-07-07T02:34:58.532Z",
          _id: "64a779d24a027297a275730b",
        },
        {
          text: "Note added to case by TESS",
          createdAt: "2023-07-07T02:29:24.793Z",
          _id: "64a7788598d2360423c4a1f3",
        },
        {
          text: "Note added to case by TESS",
          createdAt: "2023-07-07T02:29:15.601Z",
          _id: "64a7787b4a027297a27571c7",
        },
      ],
      createdAt: "2023-07-07T02:18:36.614Z",
      updatedAt: "2023-07-07T05:00:13.142Z",
      __v: 0,
      severity: "Level 2",
      caseOwner: "Diane",
      status: "Read",
      id: "64a775fc9066ab70a9f461ff",
    },
    {
      pendingSuspension: {
        platforms: [],
      },
      startDate: {
        month: "February",
        day: 3,
        year: 2022,
      },
      complaintAgainst: {
        iboNumber: 1478107,
        email: "dreamstream+qa.1478107.1463.5@wwdb.com",
        firstName: "RANDY",
        lastName: "JASSMAN",
        phoneNumber: "(509) 995-6003",
        address: "1717 PENINSULA RD",
        city: "HOPE",
        state: "ID",
        zipCode: "83836-9753",
      },
      documentation: {
        evidence: [],
      },
      _id: "64a7748b494fc8a2dd5f48c8",
      primaryIboNumber: 6996617,
      primaryEmail: "dreamstream+qa.6996617.1446364.5@wwdb.com",
      firstName: "HEATHER",
      lastName: "ADAM",
      phoneNumber: "(403) 771-0026",
      address: "21 BERKELEY PL W 322",
      city: "LETHBRIDGE",
      state: "AB",
      zipCode: "T1K5N1",
      problemType: "Hate Speech/Racism",
      problemLocation: "Online Platform",
      subLocation: "DreamStream",
      description: "sadf",
      evidence: [
        {
          type: "image/jpeg",
          src: "https://wwgusdev.blob.core.windows.net/security-app/b85a2d20-1c6b-11ee-85f8-c7f063076001.jpg",
          name: "GettyImages-1145794687.jpg",
          downloadPath: "security-app/b85a2d20-1c6b-11ee-85f8-c7f063076001.jpg",
        },
      ],
      isMember: "Yes",
      hasViolated: "Yes",
      fromUpline: "Yes",
      recentActivity: [],
      reminders: [],
      incidentNotes: [],
      events: [],
      historyOfActions: [],
      createdAt: "2023-07-07T02:12:27.978Z",
      updatedAt: "2023-07-07T02:12:27.978Z",
      __v: 0,
      id: "64a7748b494fc8a2dd5f48c8",
    },
    {
      pendingSuspension: {
        platforms: [],
      },
      startDate: {
        month: "November",
        day: 3,
        year: 2021,
      },
      complaintAgainst: {
        iboNumber: 7789,
        email: "dreamstream+qa.7789.1247.5@wwdb.com",
        firstName: "BILL",
        lastName: "HAWKINS",
        phoneNumber: "(763) 242-5300",
        address: "4680 - 152ND CT NW",
        city: "RAMSEY",
        state: "MN",
        zipCode: "55303",
      },
      documentation: {
        evidence: [],
      },
      _id: "64a726a3ff5733c044522d1d",
      primaryIboNumber: 4745557,
      primaryEmail: "dreamstream+qa.4745557.770648.5@wwdb.com",
      firstName: "JOHN",
      lastName: "BAKER",
      phoneNumber: "(425) 334-1936",
      address: "123",
      city: "wa",
      state: "wa",
      zipCode: "12312",
      problemType: "Hate Speech/Racism",
      problemLocation: "Online Platform",
      subLocation: "DreamStream",
      description: "west",
      evidence: [
        {
          type: "image/jpeg",
          src: "https://wwgusdev.blob.core.windows.net/security-app/488a9ad0-1c3d-11ee-a1ca-a54a38ba42a7.jpg",
          name: "GettyImages-1145794687 - Copy.jpg",
          downloadPath: "security-app/488a9ad0-1c3d-11ee-a1ca-a54a38ba42a7.jpg",
        },
        {
          type: "image/jpeg",
          src: "https://wwgusdev.blob.core.windows.net/security-app/48c44870-1c3d-11ee-a1ca-a54a38ba42a7.jpg",
          name: "GettyImages-1145794687.jpg",
          downloadPath: "security-app/48c44870-1c3d-11ee-a1ca-a54a38ba42a7.jpg",
        },
      ],
      isMember: "Yes",
      hasViolated: "Yes",
      fromUpline: "Yes",
      recentActivity: [],
      reminders: [],
      incidentNotes: [],
      events: [],
      historyOfActions: [],
      createdAt: "2023-07-06T20:40:03.555Z",
      updatedAt: "2023-07-06T20:40:03.555Z",
      __v: 0,
      id: "64a726a3ff5733c044522d1d",
    },
    {
      escalation: {
        reason: "asfd",
        actionsNeeded: "asdf",
        createdAt: "2023-07-07T02:40:36.269Z",
      },
      notes: {
        title: "Escalated - Investigation",
        body: "asfd - asdf",
        createdAt: "2023-07-07T02:40:36.269Z",
      },
      pendingSuspension: {
        platforms: [],
      },
      startDate: {
        month: "January",
        day: 1,
        year: 2021,
      },
      complaintAgainst: {
        iboNumber: 1356957,
        email: "notprovided@email.com",
        firstName: "RANDY",
        lastName: "ALCOTT",
        phoneNumber: "(253) 265-2199",
        address: "dasf",
        city: "wa",
        state: "wa",
        zipCode: "12312",
      },
      documentation: {
        evidence: [],
        description: "fdafs test",
      },
      _id: "64a634676ae9d058de3df78c",
      primaryIboNumber: 1478107,
      primaryEmail: "dreamstream+qa.1478107.1463.5@wwdb.com",
      firstName: "RANDY",
      lastName: "JASSMAN",
      phoneNumber: "(509) 995-6003",
      address: "1717 PENINSULA RD",
      city: "HOPE",
      state: "ID",
      zipCode: "83836-9753",
      problemType: "Harassment",
      problemLocation: "In Person",
      subLocation: "DreamStream",
      description: "fdafs",
      evidence: [
        {
          type: "image/jpeg",
          src: "https://wwgusdev.blob.core.windows.net/security-app/e70f79a0-1bac-11ee-9a15-735bd5c45b7d.jpg",
          name: "GettyImages-1145794687.jpg",
          downloadPath: "security-app/e70f79a0-1bac-11ee-9a15-735bd5c45b7d.jpg",
        },
      ],
      isMember: "Yes",
      hasViolated: "Yes",
      fromUpline: "Yes",
      recentActivity: [
        {
          date: "2023-07-06T20:19:21.613Z",
          message:
            "Disciplinary Letter - Physical Therapist email sent to: dreamstream+qa.1478107.1463.5@wwdb.com",
          _id: "64a721c9c661131412823797",
        },
      ],
      reminders: [],
      incidentNotes: [
        {
          title: "123",
          text: "123",
          files: [],
          createdAt: "2023-07-07T02:35:57.785Z",
          _id: "64a77a0ddc55e70524038e9f",
        },
        {
          title: "123",
          text: "123",
          files: [],
          createdAt: "2023-07-06T20:17:40.770Z",
          _id: "64a72164c661131412823664",
        },
      ],
      events: [],
      historyOfActions: [
        {
          text: "Escalated - Investigation",
          createdAt: "2023-07-07T02:40:36.269Z",
          _id: "64a77b2464bd9b2390aae4ba",
        },
        {
          text: "Escalated - Investigation",
          createdAt: "2023-07-07T02:38:25.564Z",
          _id: "64a77aa10a8a795d3aed95bc",
        },
        {
          text: "Escalated - Investigation",
          createdAt: "2023-07-07T02:38:14.073Z",
          _id: "64a77a964a027297a27575a0",
        },
        {
          text: "Note added to case by RANDY",
          createdAt: "2023-07-07T02:35:57.785Z",
          _id: "64a77a0ddc55e70524038ea0",
        },
        {
          text: "Note added to case by RANDY",
          createdAt: "2023-07-06T20:17:40.770Z",
          _id: "64a72164c661131412823665",
        },
        {
          text: "Case description updated",
          createdAt: "2023-07-06T20:17:28.073Z",
          _id: "64a72158001e4f90c6f48000",
        },
      ],
      createdAt: "2023-07-06T03:26:32.355Z",
      updatedAt: "2023-07-07T02:40:36.274Z",
      __v: 0,
      severity: "Level 3",
      caseOwner: "Unassigned",
      status: "Read",
      id: "64a634676ae9d058de3df78c",
    },


  ]);

  const [incidentFilters, setIncidentFilters] = useState({
    status: null,
    type: null,
    severity: null,
    caseOwner: null,
    start: null,
    end: null,
    search: null,
  });

  const filteredIncidents = useMemo(() => {
    // Resets filtered incidents if filters are empty.
    const newIncidents = Object.values(incidentFilters).every((value) => !value)
      ? mockIncidents
      : mockIncidents.filter((incident) => {
          const testEntry = ([key, value]) =>
            (!incidentFilters[key] && !["start", "end"].includes(key)) ||
            value.includes(incidentFilters[key]);
          // Test if no filter or if specified filter (not search or date) matches
          let retBool = Object.entries(incident).every(testEntry);

          // Apply date filter if included
          if (retBool && incidentFilters.end) {
            const dateCreated = new Date(incident.dateCreated).getTime();

            retBool =
              incidentFilters.end.getTime() >= dateCreated &&
              incidentFilters.start.getTime() <= dateCreated;
          }

          // Apply search filter if included
          if (retBool && incidentFilters.search?.trim()) {
            const regExp = new RegExp(incidentFilters.search, "i");
            retBool = Object.values(incident).some((value) =>
              regExp.test(value)
            );
          }

          return retBool;
        });
    return newIncidents;
  }, [incidentFilters, mockIncidents]);

  // Security Brief and Event Summary
  const [briefDownload, setBriefDownload] = useState(null);
  const [summaryDownload, setSummaryDownload] = useState(null);
  const [wasShared, setWasShared] = useState(false);
  const pdfRef = useRef();

  // Modals
  const [openModal, setOpenModal] = useState(null);

  useEffect(() => {
    if (localStorage.getItem("ReloadBrief")) {
      setOpenModal("Security Brief");
      pdfRef.current.src = localStorage.getItem("ReloadBrief");
      localStorage.removeItem("ReloadBrief");
    } else if (localStorage.getItem("ReloadSummary")) {
      setOpenModal("Event Summary");
      pdfRef.current.src = localStorage.getItem("ReloadSummary");
      localStorage.removeItem("ReloadSummary");
    }
  }, []);

  // Replace with API call
  const mockKeyContacts = KeyContactsListData.args.keyContacts;
  const contactsEditList = useMemo(
    () =>
      mockKeyContacts.map((contact) => {
        const [lastName, firstName] = contact.name.split(", ");
        return {
          position: contact.position,
          firstName: firstName,
          lastName: lastName,
          phoneNumber: contact.number,
          email: contact.email,
        };
      }),
    [mockKeyContacts]
  );

  return (
    <div className={styles["scroll-container"]}>
      <section
        className={styles.container}
        style={{ overflowY: openModal ? "hidden" : "scroll" }}
      >
        <div className={styles.header}>
          <h1>Event Details</h1>
          <div
            onClick={() => setIsOpenActions(!isOpenActions)}
            className={classNames(styles["action-select-container"], {
              [styles.closed]: !isOpenActions,
              [styles.open]: isOpenActions,
            })}
            ref={wrapperRef}
          >
            <Select
              options={["Send Security Brief", "Export Report", " Edit Info"]}
              placeholder={"Actions"}
              onChange={(option) => {
                if (option === "Send Security Brief") {
                  setOpenModal("Security Brief");
                  if (briefDownload) pdfRef.current.src = briefDownload.url;
                } else if (option === "Export Report") {
                  setOpenModal("Event Summary");
                }
              }}
            />
          </div>
        </div>
        <div className={styles["card-div"]}>
          <EventInfoCard {...EventInfoCardData.args} />
        </div>
        <div className={styles["card-div"]}>
          <EventCenterInfoCard {...EventCenterInfoCardData.args} />
        </div>
        <section>
          <div className={styles.header}>
            <h1 className={styles.headerTwo}>Records</h1>
          </div>
          <div className={styles["split-flex"]}>
            <TabContainer
              minHeight="280px"
              className={styles["tab-container"]}
              children={[
                <Tab key={v4()} title="Emergency" value="Emergency">
                  <EmergencyList {...EmergencyListData.args} />
                </Tab>,
                <Tab key={v4()} title="Key Locations" value="Key Locations">
                  <KeyLocationsList {...KeyLocationsListData.args} />
                </Tab>,
                <Tab key={v4()} title="Documents" value="Documents">
                  <DocumentsList {...DocumentsListData.args} />
                </Tab>,
              ]}
            />
            <Card
              className={classNames(
                styles.card,
                styles["special-circumstances"]
              )}
              children={
                <SpecialCircumstances
                  specialCircumstances={specialCircumstances}
                  onSave={(value) => {
                    alert("onSave clicked.");
                    setSpecialCircumstances(value);
                  }}
                />
              }
            />
          </div>
        </section>
        <section>
          <div className={styles.header}>
            <h1 className={styles.headerTwo}>Staff</h1>
          </div>
          <div className={styles["split-flex"]}>
            <TabContainer
              minHeight="350px"
              className={styles["tab-container"]}
              children={[
                <Tab key={v4()} title="Key Contacts" value="Key Contacts">
                  <div className={styles["staff-list-container"]}>
                    <KeyContactsList
                      {...KeyContactsListData.args}
                      onEdit={() => setOpenModal("Key Contacts")}
                    />
                  </div>
                </Tab>,
                <Tab key={v4()} title="Security Team" value="Security Team">
                  <div className={styles["staff-list-container"]}>
                    <SecurityTeamList
                      securityTeamList={mockSecurityTeamList}
                      onPin={(pinStatus, team) => {
                        const newList = onMockPinStaff(
                          pinStatus,
                          team,
                          mockSecurityTeamList
                        );
                        setMockSecurityTeamList(newList);
                      }}
                      header="Security Team"
                    />
                  </div>
                </Tab>,
                <Tab key={v4()} title="Event Staff" value="Event Staff">
                  <div className={styles["staff-list-container"]}>
                    <SecurityTeamList
                      securityTeamList={mockEventStaffList}
                      onPin={(pinStatus, team) => {
                        const newList = onMockPinStaff(
                          pinStatus,
                          team,
                          mockEventStaffList
                        );
                        setMockEventStaffList(newList);
                      }}
                      header="Event Staff"
                    />
                  </div>
                </Tab>,
              ]}
            />
            <span />
          </div>
        </section>
        <section>
          <div className={classNames(styles["sub-header"])}>
            <h1 className={styles.headerTwo}>Filter Nearby Incidents</h1>
          </div>
          <div
            className={classNames(
              styles["card-div"],
              styles["filter-incident-container"]
            )}
          >
            <FilterNearbyIncidentsMenu
              onClick={(filters) => {
                // Replace empty filters with null
                let _filters = Object.fromEntries(
                  Object.entries(filters).map(([key, value]) => {
                    return key === "search"
                      ? [key, value === "" ? null : value]
                      : [
                          key,
                          typeof value === "string" &&
                          ["Select", ""].includes(value.trim())
                            ? null
                            : value,
                        ];
                  })
                );
                setIncidentFilters(_filters);
              }}
            />
          </div>
        </section>
        <section>
          <div className={styles["card-div"]}>
            <Card
              children={
                <div className={styles["card-content"]}>
                  <div className={styles["card-header"]}>
                    <p>Nearby Incidents</p>
                  </div>
                  <div className={styles["incidents-list-container"]}>
                    <IncidentsList incidents={filteredIncidents} />
                  </div>
                </div>
              }
              className={classNames(
                styles.card,
                styles["nearby-incidents-card"]
              )}
            />
          </div>
        </section>
        <div
          className={classNames(styles["key-contacts-modal"], styles.overlay, {
            [styles.hidden]: openModal !== "Key Contacts",
          })}
        >
          <EditKeyContactsModal
            contacts={contactsEditList}
            isOpen={openModal === "Key Contacts"}
            onSave={() => alert("onSave clicked.")}
            onClose={() => setOpenModal(null)}
          />
        </div>
        <section
          className={classNames(
            styles.overlay,
            styles["solid-overlay"],
            styles["brief-container"],
            {
              [styles.hidden]: !["Security Brief", "Event Summary"].includes(
                openModal
              ),
            }
          )}
        >
          <div>
            <div>
              {openModal === "Security Brief" ? (
                <SecurityBriefDocument
                  keyContacts={KeyContactsListData.args.keyContacts}
                  keyLocations={KeyLocationsListData.args.locationItems}
                  selectedDocs={[TestSecurityBrief, TestSecurityBrief]}
                  onLoad={(data) => {
                    setBriefDownload(data);
                    pdfRef.current.src = data.url;
                  }}
                />
              ) : (
                <EventSummaryDocument
                  {...EventSummaryDocumentProps.args}
                  onLoad={(data) => {
                    setSummaryDownload(data);
                    pdfRef.current.src = data.url;
                  }}
                />
              )}
              <iframe hidden title={openModal} ref={pdfRef} />
            </div>
          </div>
          <div>
            <Card
              className={classNames(
                styles.card,
                styles["document-options-container"]
              )}
              children={
                <div className={styles["document-options-button-group"]}>
                  <button
                    type="button"
                    onClick={() => {
                      if (pdfRef.current.src) {
                        pdfRef.current.contentWindow.print();
                      }
                    }}
                  >
                    <PrinterIcon />
                    <p>Print</p>
                  </button>
                  <a
                    href={
                      pdfRef.current?.src
                        ? openModal === "Security Brief"
                          ? briefDownload?.url
                          : summaryDownload?.url
                        : "#"
                    }
                    download={
                      openModal === "Security Brief"
                        ? "SecurityBriefDocument.pdf"
                        : "EventSummary.pdf"
                    }
                    disabled={!pdfRef.current?.src}
                  >
                    <FloppyDiskIcon />
                    <p>Save As</p>
                  </a>
                  <button
                    type="button"
                    onClick={async () => {
                      const callReload = () => {
                        const confirm = window.confirm(
                          "You must reload the page to share again. Press OK to reload."
                        );
                        if (confirm) {
                          if (openModal === "Security Brief") {
                            localStorage.setItem(
                              "ReloadBrief",
                              briefDownload.url
                            );
                          } else {
                            localStorage.setItem(
                              "ReloadSummary",
                              summaryDownload.url
                            );
                          }
                          window.location.reload(true);
                        }
                      };

                      const files =
                        briefDownload && openModal === "Security Brief"
                          ? [
                              new File(
                                [briefDownload.blob],
                                "SecurityBriefDocument.pdf",
                                { type: "application/pdf" }
                              ),
                            ]
                          : summaryDownload && openModal === "Event Summary"
                          ? [
                              new File(
                                [summaryDownload.blob],
                                "EventSummary.pdf",
                                {
                                  type: "application/pdf",
                                }
                              ),
                            ]
                          : null;

                      if (files) {
                        if (navigator.canShare({ files })) {
                          await navigator
                            .share({ files })
                            .catch((_) => callReload());
                        }
                      }
                    }}
                    disabled={!navigator.canShare}
                    className={classNames({
                      [styles["disabled-button"]]: !navigator.canShare,
                    })}
                  >
                    <EnvelopeIcon />
                    <p>Send in Email</p>
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      setOpenModal(null);
                      setWasShared(false);
                    }}
                  >
                    Back
                  </button>
                </div>
              }
            />
          </div>
        </section>
      </section>
    </div>
  );
}
